import React, { useRef } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { RiArrowGoBackLine, RiArrowGoForwardLine } from "react-icons/ri";

const modules = {
  toolbar: [
    ["bold", "italic", "underline", "strike"],
    ["blockquote", "code-block"],
    ["link"], // Removed "undo", "redo" here
    [{ header: 1 }, { header: 2 }],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ script: "sub" }, { script: "super" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ direction: "rtl" }],
    [{ size: ["small", false, "large", "huge"] }],
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],
    ["clean"],
  ],
  history: {
    delay: 1000,
    maxStack: 100,
    userOnly: true,
  },
};

interface RichTextEditorProps {
  value: string;
  onChange: (content: string) => void;
}

export default function RichTextEditor({
  value,
  onChange,
}: RichTextEditorProps) {
  const quillRef = useRef<ReactQuill | null>(null);

  const handleUndo = () => {
    const editor = quillRef.current?.getEditor() as any;
    editor?.history.undo();
  };

  const handleRedo = () => {
    const editor = quillRef.current?.getEditor() as any;
    editor?.history.redo();
  };

  return (
    <div>
      <div className="mb-2 space-x-2">
        <button onClick={handleUndo}>
          <RiArrowGoBackLine className="inline w-5 h-5" />
        </button>

        <button onClick={handleRedo}>
          <RiArrowGoForwardLine className="inline w-5 h-5" />
        </button>
      </div>
      <ReactQuill
        ref={quillRef}
        modules={modules}
        theme="snow"
        value={value}
        onChange={onChange}
      />
    </div>
  );
}
